<template>
	<q-list class="q-mb-md">
		<q-collapsible icon="fas fa-filter" v-model="open" @click="toggle" :label="getNameFilter">
			<div class="row gutter-sm" v-if="options">
				<div
					class="col-xs-12 col-sm-12"
					v-if="options.user_areas && options.user_areas.length"
				>
					<select-multiple
						label="areas"
						:filters="filters.user_area"
						:options="options.user_areas"
						@on_value="filters.user_area = $event"
					/>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="options.profiles">
					<q-select
						v-model="filters.profile"
						chips
						:options="options.profiles"
						multiple
						:float-label="$t('profiles')"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="options.statuses">
					<q-select
						chips
						multiple
						v-model="filters.status"
						:options="options.statuses"
						:float-label="$t('status')"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="options.has_filter_companies">
					<q-chips-input
						v-model="filters.companies_label"
						:float-label="`${$t('headquarter')} (${filters.companies_label.length})`"
						@remove="removeHeadquarter"
						:placeholder="$t('enter_the_company_or_chain_name')"
					>
						<q-autocomplete
							@search="fetchHeadquarters"
							@selected="selectHeadquarter"
							:debounce="500"
							:min-characters="1"
							:max-results="100"
						/>
					</q-chips-input>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="options.has_filter_store">
					<q-chips-input
						v-model="filters.company_branches_label"
						:float-label="`${$t('branch')} (${filters.company_branches_label.length})`"
						@remove="removeBranch"
						:placeholder="$t('enter_the_store_or_branch_name')"
					>
						<q-autocomplete
							@search="fetchBranches"
							@selected="selectBranch"
							:debounce="500"
							:min-characters="3"
							:max-results="100"
						/>
					</q-chips-input>
				</div>
			</div>
			<div class="row gutter-sm justify-end q-mt-sm">
				<div class="col-xs-12 col-sm-3">
					<q-btn
						color="negative"
						class="full-width"
						:label="$t('clear_filters')"
						icon="fas fa-eraser"
						@click="clearFilter()"
					/>
				</div>
				<div class="col-xs-12 col-sm-3">
					<q-btn
						color="secondary"
						class="full-width"
						:label="$t('apply_filter_plural')"
						icon="fas fa-filter"
						@click="requestFiltered()"
					/>
				</div>
			</div>
		</q-collapsible>
	</q-list>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectMultiple from '../utils/SelectMultiple.vue'
export default {
	props: ['options'],
	data() {
		return {
			open: false,
			filters: {
				status: [],
				profile: [],
				user_area: [],
				companies_label: [],
				companies: [],
				company_branches: [],
				company_branches_label: [],
			},
		}
	},
	components: {
		'select-multiple': SelectMultiple,
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			users_filters: 'admin_filters/users_filters',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getNameFilter() {
			if (Object.entries(this.filters).find((a) => a[1] && a[1].length > 0)) {
				return `${this.$t('filter')} <i class="fas fa-exclamation-circle"></i>`
			} else return this.$t('filter')
		},
	},

	methods: {
		fetchHeadquarters(terms, done) {
			this.$axios
				.get(`/admin_companies/companies/get_companies/?search=${terms}`, this.getHeader)
				.then((response) => {
					let headquarters = []
					headquarters = response.data.map((element) => {
						return {
							id: element.id,
							label: element.name,
							value: element.name,
						}
					})
					done(headquarters)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectHeadquarter(item) {
			this.filters.companies.push(item.id)
		},

		removeHeadquarter({ index, value }) {
			this.filters.companies.splice(index, 1)
			this.clearStoredFilters()
		},

		fetchBranches(terms, done) {
			this.$axios
				.get(`/admin_companies/branches/get_branches/?search=${terms}`, this.getHeader)
				.then((response) => {
					let stores = []
					stores = response.data.map((store) => {
						return {
							id: store.id,
							label: `${store.name} / ${
								store.document && store.register
									? `${store.document} - ${store.register}`
									: store.document
									? store.document
									: store.register
									? store.register
									: ''
							}`,
							value: `${store.name} / ${
								store.document && store.register
									? `${store.document} - ${store.register}`
									: store.document
									? store.document
									: store.register
									? store.register
									: ''
							}`,
						}
					})
					done(stores)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectBranch(item) {
			this.filters.company_branches.push(item.id)
		},

		removeBranch({ index }) {
			this.filters.company_branches.splice(index, 1)
			this.clearStoredFilters()
		},

		requestFiltered() {
			this.$emit('requestFiltered', {
				status: this.filters.status,
				profile: this.filters.profile,
				user_area: this.filters.user_area,
				companies: this.filters.companies,
				company_branches: this.filters.company_branches,
			})
			this.saveUsersFilters()
			setTimeout(() => {
				this.toggle()
			}, 500)
		},

		clearFilter() {
			this.filters.status = []
			this.filters.profile = []
			this.filters.user_area = []
			this.filters.companies_label = []
			this.filters.companies = []
			this.filters.company_branches = []
			this.filters.company_branches_label = []
			this.$emit('clearAndRequest')
			this.clearStoredFilters()
			setTimeout(() => {
				this.toggle()
			}, 500)
		},

		toggle() {
			this.open = !this.open
		},

		saveUsersFilters(obj) {
			this.$store.dispatch('admin_filters/SET_USERS_FILTERS', { users_filters: this.filters })
		},

		loadUsersFilters() {
			this.filters = this.users_filters
			setTimeout(() => {
				this.requestFiltered()
			}, 1000)
		},

		clearStoredFilters() {
			this.$store.dispatch('admin_filters/SET_USERS_FILTERS', { users_filters: {} })
		},
	},

	mounted() {
		if (this.users_filters && this.users_filters.status) {
			this.loadUsersFilters()
		}
	},
}
</script>

<style></style>
